export default ({ choice, items }: { choice: Choice; items: Items }) => ({
  ...items[choice.id],
  name: choice.name,
});
